import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { PatientAuthenticationService } from '../services/patientAuthentication.service';

@Injectable({ providedIn: 'root' })
export class PatientAuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private patientAuthService: PatientAuthenticationService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.patientAuthService.getCurrentUser();

    if (currentUser) {
      return true;
    }
    localStorage.setItem('returnURL', state.url);
    localStorage.setItem('returnURLParameters', JSON.stringify(route.queryParams));
    this.router.navigate(['/patientLogin'], { });

    return false;
  }

}
